import React from 'react';
import { Box } from '@stockx/ui';

const Main = ({ children }) => (
  <Box
    as="main"
    role="main"
    minHeight="100vh"
    data-component="Main"
    id="main-content"
    mt="0px"
  >
    {children}
  </Box>
);

export default Main;
